/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import React from 'react';
import { Sanitize } from 'src/DistributionPackages/BestFit.Magicline/Resources/Private/App/Components/Sanitizer';
import PropTypes from 'prop-types';

/**
 * TrialSessionSucess Component
 * @param props
 * @returns {Element}
 * @constructor
 */
function TrialSessionSuccess(props) {
  const { confirmationContent } = props;

  return (<Sanitize value={confirmationContent} />);
}

export default TrialSessionSuccess;

TrialSessionSuccess.propTypes = {
  confirmationContent: PropTypes.object.isRequired,
};
